<template>
    <div id="app" class="py-5">
      <vue-editor v-model="content"
          v-bind="$props"
          v-on:keyup.enter="keyupEnter"
          :placeholder="label"  
      ></vue-editor>
      <div v-if="errorMessages.length" class="error-message">
        {{errorMessages[0]}}
      </div>
    </div>
  </template>
  <script>
  import { VueEditor } from "vue2-editor";
  export default {
    components: {
      VueEditor
    },
    props: {
      value: {
        type: Number | String,
        required: false
      },
      errorMessages: {
        type: Array,
        requred: false
      },
      label: {
        type: String,
        required: false
      },
      keyupEnter: {
        type: Function,
        required: false
      },
      required: {
        type: Boolean,
        required: false,
        default: true
      }
  },
  data() {
    return {
      content: "",
    };
    },
  mounted() {
    this.syncContentWithValue()
  },
  methods: {
    syncContentWithValue() {
      this.content = this.value
    }
  },
  watch: {
    value: {
      handler() {
        this.syncContentWithValue()
      }
    },
    content: {
      handler() {
        this.$emit('input', this.content)
      }
    }
  }
  };
  </script>
  <style>
  .error-message{
    color:red;
  }
  #quill-container{
    border-bottom-right-radius: 10px; 
    border-bottom-left-radius: 10px; 
  }
  .ql-toolbar.ql-snow{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    
  }
  </style>